import { Box, Button } from '@mui/material';
import { NavLocation } from '@schamburg-web/interfaces';
import React from 'react';
import { Link } from 'react-router-dom';

const NavLink: React.FC<{ location: NavLocation }> = ({ location }) => {
  const commonProps = {
    title: `Click to access ${location.name}`,
    'aria-label': `Navigate to ${location.name}`,
    sx: {
      paddingRight: 3,
      paddingLeft: 3,
      textAlign: 'center',
      color: 'inherit',
    },
  };

  if (location.onClick) {
    // It's an action button
    return (
      <Button {...commonProps} onClick={location.onClick}>
        {location.name}
      </Button>
    );
  } else if (location.link) {
    // It's a link button
    return (
      <Button
        {...commonProps}
        component={Link}
        to={location.link}
        target={location.target}
      >
        {location.name}
      </Button>
    );
  } else if (location.component) {
    // If a component is provided but no link or onClick, render the component
    return <Box>{location.component}</Box>;
  } else {
    return null;
  }
};

export default NavLink;
